import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  alternativeOffersCphOsl,
  orderCancelAndRefundTypeInvoluntary,
  orderEligibilitiesMockEligibleForInvolutaryRefundOneWayDisruptedUsingAmop,
  orderWithInvolutaryRefundEligibleOneWayDisruptedUsingAmop,
} from '../../../mock/data';
import {
  flightDisruptionWarning,
  orderEligibleForManualRefund,
} from '../../../mock/dictionaries';

export const involuntaryRefundUsingAmopMock: MockMap = {
  retrieveOrder: [createMockData(orderWithInvolutaryRefundEligibleOneWayDisruptedUsingAmop, [], [flightDisruptionWarning])],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleForInvolutaryRefundOneWayDisruptedUsingAmop, [], [orderEligibleForManualRefund])],
  getAlternativeOffers: [createMockData(alternativeOffersCphOsl)],
  cancelAndRefundOrder: [createMockData(orderCancelAndRefundTypeInvoluntary)]
};
